import { render, staticRenderFns } from "./ContainerPoints.vue?vue&type=template&id=6b388626"
import script from "./ContainerPoints.vue?vue&type=script&lang=js"
export * from "./ContainerPoints.vue?vue&type=script&lang=js"
import style0 from "./ContainerPoints.vue?vue&type=style&index=0&id=6b388626&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports